import QKIcon from "./icon";
import QKText from "./text";

export const Icon = QKIcon;
export const Text = QKText;
